/**
 * Japanese (JPY) tag-focused transaction feed for the tags use case.
 */

/** @type {Array<import('../../mock-tagged-transactions.js').MockTaggedTransaction>} */
export const MOCK_TAGGED_TRANSACTIONS_JA = [
	{
		id: 'tag-1',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 5400,
		description: '取引先ランチ',
		accountId: 'acc-credit',
		accountName: 'クレジットカード',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '事業, 税務',
	},
	{
		id: 'tag-2',
		date: '2026-08-01',
		type: 'Deposit',
		amount: 350000,
		description: '給与',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '収入',
	},
	{
		id: 'tag-3',
		date: '2026-07-29',
		type: 'Withdrawal',
		amount: 80000,
		description: '家賃',
		accountId: 'acc-checking',
		accountName: 'みどり銀行',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '住居費',
	},
	{
		id: 'tag-4',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 12500,
		description: '業務書籍',
		accountId: 'acc-credit',
		accountName: 'クレジットカード',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '事業, 税務',
	},
	{
		id: 'tag-5',
		date: '2026-07-20',
		type: 'Purchase',
		amount: 22000,
		description: 'ソフトウェア利用料',
		accountId: 'acc-credit',
		accountName: 'クレジットカード',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '事業, 税務',
	},
	{
		id: 'tag-6',
		date: '2026-07-18',
		type: 'Purchase',
		amount: 3200,
		description: 'スーパー',
		accountId: 'acc-credit',
		accountName: 'クレジットカード',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: '食費',
	},
];
